var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "org-tree-layout" },
      [
        _c("swb-popover-org-tree", {
          attrs: {
            showMgmt: true,
            showIncludeSubComs: false,
            closedComSelect: true,
            bizDepart: true
          },
          on: {
            "notity-change": function($event) {
              _vm.checkComCatChange($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "simple-row clearfix", attrs: { name: "link-btn" } },
      [
        _c("div", { staticClass: "left" }, [
          _c(
            "button",
            {
              staticClass: "swb-btn swb-btn-small",
              class: { "swb-btn-disabled": _vm.thisComId == null },
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.saveComRoleDlg()
                }
              }
            },
            [_vm._v("添加岗位")]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: {
              name: "result-data",
              height: _vm.domHeight,
              data: _vm.comRoleList,
              border: ""
            }
          },
          [
            _c("el-table-column", {
              attrs: { width: "150", prop: "name", label: "岗位名称" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("spn"),
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                      _vm.comInfo.bizUnitId
                        ? _c("i", {
                            staticClass: "swb-btn swb-btn-link el-icon-edit",
                            on: {
                              click: function($event) {
                                _vm.saveComRoleDlg(false, rows.row)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(rows.row.name))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "srcTplName",
                label: "关联职责权限名称",
                width: "150"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "排序", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _vm.userContext.scopeEntity.bizUnitId ==
                      _vm.comInfo.bizUnitId
                        ? _c("i", {
                            staticClass:
                              "icon iconfont icon-arrow-top swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.moveUpComRole(rows.row.id, true)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                      _vm.comInfo.bizUnitId
                        ? _c("i", {
                            staticClass:
                              "icon iconfont icon-arrow-bottom swb-btn-link",
                            on: {
                              click: function($event) {
                                _vm.moveUpComRole(rows.row.id, false)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "code", width: "110", label: "岗位编码" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "是否禁用", align: "center", width: "70" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.disabled
                        ? _c("span", { staticClass: "font-red" }, [
                            _vm._v("是")
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "mobAppRoleName",
                label: "移动端功能",
                width: "120"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.mobAppRoleName != null
                        ? _c("span", [_vm._v("可用")])
                        : _c("span", { staticClass: "font-red" }, [
                            _vm._v("不可用")
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "150",
                prop: "createTime",
                label: "创建时间"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                width: "150",
                prop: "rescChangeTime",
                label: "变更时间"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "操作" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.srcTplId == -1
                        ? [
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.showRoleRescDlg(
                                          rows.row.id,
                                          rows.row.name,
                                          rows.row.srcTplId
                                        )
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("PC功能")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.showBusinessSetDlg(
                                          _vm.comInfo.id,
                                          rows.row.id,
                                          rows.row.name,
                                          rows.row.srcTplId
                                        )
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("PC操作权限")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.appResc(rows.row)
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("移动功能")])]
                                )
                              : _vm._e()
                          ]
                        : [
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.showRoleRescDlgForTpl(
                                          rows.row.srcTplId
                                        )
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("PC功能")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.showBusinessSetDlgForTpl(
                                          rows.row.srcTplId
                                        )
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("PC操作权限")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.appRescForTpl(rows.row.srcTplId)
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("移动功能")])]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !rows.row.disabled
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "swb-btn swb-btn-link",
                                    on: {
                                      click: function($event) {
                                        _vm.bizPermScopeBusinessSetDlg(
                                          rows.row.srcTplId
                                        )
                                      }
                                    }
                                  },
                                  [_c("span", [_vm._v("数据范围")])]
                                )
                              : _vm._e()
                          ],
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                        _vm.comInfo.bizUnitId &&
                      !rows.row.disabled &&
                      rows.row.srcTplId == -1
                        ? _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.contactTpl(rows.row.id, rows.row.srcTplId)
                                }
                              }
                            },
                            [_c("span", [_vm._v("关联职责权限")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                        _vm.comInfo.bizUnitId &&
                      !rows.row.disabled &&
                      rows.row.srcTplId != -1
                        ? _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.contactTpl(rows.row.id, rows.row.srcTplId)
                                }
                              }
                            },
                            [_c("span", [_vm._v("更换关联职责权限")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                        _vm.comInfo.bizUnitId && !rows.row.disabled
                        ? _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.srelevPersons(rows.row)
                                }
                              }
                            },
                            [_c("span", [_vm._v("批量分配岗位")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                      _vm.comInfo.bizUnitId
                        ? _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.updateDisable(
                                    rows.row.id,
                                    rows.row.disabled
                                  )
                                }
                              }
                            },
                            [
                              rows.row.disabled
                                ? _c("span", [_vm._v("启用")])
                                : _c("span", [_vm._v("禁用")])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.userContext.scopeEntity.bizUnitId ==
                        _vm.comInfo.bizUnitId && rows.row.disabled
                        ? _c(
                            "div",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.doDelete(rows.row.id)
                                }
                              }
                            },
                            [_c("span", [_vm._v("删除")])]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.toQrCode(rows.row)
                            }
                          }
                        },
                        [_c("span", [_vm._v("岗位二维码")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.setArea(rows.row)
                            }
                          }
                        },
                        [_c("span", [_vm._v("负责布放区")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.showRefStaffList(rows.row.id)
                            }
                          }
                        },
                        [_c("span", [_vm._v("查询岗位人员")])]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-145f6a77", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-145f6a77","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/ComRoleList.vue
// module id = 3474
// module chunks = 0